import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Container } from "./styled/input";
const Input = forwardRef(({
  isFullWidth = true,
  ...props
}, ref) => {
  return <Container {...props} ref={ref} isFullWidth={isFullWidth} />;
});
Input.propTypes = {
  isFullWidth: PropTypes.bool
};
export default Input;